module.exports = __webpack_public_path__ + "img/food7.73be696f.jpg";